import React, { useState, useEffect } from 'react';
import { WithStyles } from '@material-ui/core/styles';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { withRouter, RouteComponentProps, useParams } from 'react-router-dom';

import { useQuery } from '@apollo/client';

import { withStyles } from '@material-ui/core';

import Dashboard from '../../../../../layouts/Dashboard';
import ViewLocationIntegrations from '../../../../../components/Global/LocationIntegrations/View';

import { selectLocationSettingsInitQuery, Location } from './queries';

import styles from './styles';

interface Props extends WithStyles<typeof styles>, RouteComponentProps {
  classes: ClassNameMap<string>;
}

interface UrlParams {
  location_id: string;
}

const ViewLocationSettings = ({ classes, history }: Props): React.ReactElement => {
  const { location_id } = useParams<UrlParams>();

  const [location, setLocation] = useState<Location>({
    name: '',
  });

  const { data: locationSettingsQuery } = useQuery(selectLocationSettingsInitQuery(location_id), { fetchPolicy: 'no-cache' });

  useEffect(() => {
    let mounted = true;
    if (mounted && locationSettingsQuery) {
      setLocation(locationSettingsQuery.locations_by_pk);
    }
    return () => {
      mounted = false;
    };
  }, [locationSettingsQuery]);

  const handleEdit = (step: number) => {
    history.push(`/org/locations/${location_id}/integrations/edit?step=${step}`);
  };

  return (
    <Dashboard
      breadcrumbs={[
        { label: 'Locations', link: `/org/locations` },
        { label: location.name, link: `/org/locations/${location_id}` },
        { label: 'Integrations', link: `/org/locations/${location_id}/integrations` },
      ]}>
      <ViewLocationIntegrations location_id={location_id} handleEdit={handleEdit} />
    </Dashboard>
  );
};

export default withRouter(withStyles(styles)(ViewLocationSettings));
